import styled, { css, keyframes } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { SCROLL_SELECT_ITEM_HEIGHT } from './config';
import { LayoutConst } from 'core';

export const Container = styled(FlexBox)`
    align-items: flex-end;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding-left: 32px;
    padding-right: 32px;
    overflow-x: hidden;
    overflow-y: hidden;
    // margin-bottom: 100px;
    margin-bottom: 30px;
    z-index: 100;
`;

export const ChooserBox = styled(FlexBox)`
    width: 100vw;
    user-select: none;
    height: calc(100vh);

    a {
      cursor: pointer;
      color: inherit;
    }
`;

export const ChooserBoxMobile = styled(FlexBox)`
    width: 100vw;
    user-select: none;
`;

/**
 * Элемент выбора
 */
 export const ChooserNode = styled(FlexBox)<{isMobile?: boolean, justify?: string, isOnlines?: boolean, isTablet?: boolean, autoHeight?: boolean }>`

  ${p => p?.isOnlines ? css`
      height: auto;
      margin-bottom: 10px;
  ` : null};
  ${({ autoHeight, isMobile }) => autoHeight ? css`
    height: auto;
    //margin-bottom: 16px;
  ` : css`
    height: ${isMobile ? "44px" : `${SCROLL_SELECT_ITEM_HEIGHT}px`};
  `};
  user-select: none;
  align-items: center;
  scroll-snap-align: center;
  width: ${p => p.isMobile ? `auto` : '50vw'};

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    ${p => p?.isOnlines ? null : css`
      width: auto;
    `};
  }

  justify-content: ${p => p.justify ? `${p.justify}` : 'flex-end'};
  cursor: pointer;
  @media only screen and (max-width: 1024px) and (min-width: 480px) {
      line-height: 40px;
    }
  &:nth-child(2) {
    margin-bottom: 200px;
  }
`;

// половина экрана
export const ChooserBoxPart = styled(FlexBox)<{scrl?: boolean}>`
    height: calc(100vh);
    user-select: none;
    max-height: calc(100vh);
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          // display: ${p => p.scrl ? "block" : "none"};
          display: none;
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
`;

/**
 * Анимация стрелки
 */
export const ArrowAnimation = keyframes`
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {

    transform: translateX(0);
    opacity: 1;
  }
`;

export const ChooserBoxPartMobile = styled(FlexBox)<{scrl?: boolean}>`
    user-select: none;
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          display: ${p => p.scrl ? "block" : "none"};
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
`;
/**
 * Анимация точки
 */
export const PointAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {

    opacity: 1;
  }
`;

/**
 * Стрелка
 */
export const Arrow = styled(FlexBox)<{externalLink?: boolean}>`
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 30px;
    padding-top: 6px;
    cursor: pointer;
    animation: ${ArrowAnimation} 0.4s linear forwards;
    ${({externalLink}) => externalLink && 'transform: rotate(-45deg)!important;'}
`;

/**
 * Контейнер выбора
 */
export const ChooserContainer = styled(FlexBox)`
    overflow-y: scroll;
    user-select: none;
    padding-top: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    padding-bottom: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    height: calc(100vh);
    max-height: calc(100vh);
    width: 100%;
    scroll-snap-type: y mandatory;
     scroll-behavior: smooth;
    box-sizing: border-box;
    border: none;
`;


// Тупо точка, которая появляется и исчезает
export const PrettyPoint = styled.div<{ visible: boolean }>`
    display: inline-block;
    opacity: ${(p) => (p.visible ? 1 : 0)};
    animation: ${(p) => (p.visible ? PointAnimation : null)} 0.4s linear forwards;
`;

/**
 * Рамки с прозрачностью
 */
export const ChooserOpacity = styled(FlexBox)`
    width: 100%;
    height: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    top: 0;
    pointer-events: none;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 1000;
    background: ${(p) => p.theme.selectContextModal.background};
    background: rgb(42, 48, 52);
    background: ${(p) => p.theme.selectContextModal.opacityTop};
`;

/**
 * Рамка с прозрачностью для низа
 */
export const ChooserOpacityBottom = styled(ChooserOpacity)`
    top: auto;
    bottom: 0;
    background: ${(p) => p.theme.selectContextModal.opacityBottom};
`;
import styled, { css, keyframes } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { SCROLL_SELECT_ITEM_HEIGHT } from './config';
import { LayoutConst } from 'core';

export const Container = styled(FlexBox)`
    align-items: flex-end;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding-left: 32px;
    padding-right: 32px;
    overflow-x: hidden;
    overflow-y: hidden;
    // margin-bottom: 100px;
    margin-bottom: 30px;
    z-index: 100;
`;

export const ChooserBox = styled(FlexBox)`
    width: 100vw;
    user-select: none;
    height: calc(100vh);

    a {
      cursor: pointer;
      color: inherit;
    }
`;

export const ChooserBoxMobile = styled(FlexBox)`
    width: 100vw;
    user-select: none;
`;

/**
 * Элемент выбора
 */
 export const ChooserNode = styled(FlexBox)<{isMobile?: boolean, justify?: string, isOnlines?: boolean, isTablet?: boolean, autoHeight?: boolean }>`

  ${p => p?.isOnlines ? css`
      height: auto;
      margin-bottom: 10px;
  ` : null};
  ${({ autoHeight, isMobile }) => autoHeight ? css`
    height: auto;
    //margin-bottom: 16px;
  ` : css`
    height: ${isMobile ? "44px" : `${SCROLL_SELECT_ITEM_HEIGHT}px`};
  `};
  user-select: none;
  align-items: center;
  scroll-snap-align: center;
  width: ${p => p.isMobile ? `auto` : '50vw'};

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    ${p => p?.isOnlines ? null : css`
      width: auto;
    `};
  }

  justify-content: ${p => p.justify ? `${p.justify}` : 'flex-end'};
  cursor: pointer;
  @media only screen and (max-width: 1024px) and (min-width: 480px) {
      line-height: 40px;
    }
  &:nth-child(2) {
    margin-bottom: 200px;
  }
`;

// половина экрана
export const ChooserBoxPart = styled(FlexBox)<{scrl?: boolean}>`
    height: calc(100vh);
    user-select: none;
    max-height: calc(100vh);
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          // display: ${p => p.scrl ? "block" : "none"};
          display: none;
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
`;

/**
 * Анимация стрелки
 */
export const ArrowAnimation = keyframes`
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {

    transform: translateX(0);
    opacity: 1;
  }
`;

export const ChooserBoxPartMobile = styled(FlexBox)<{scrl?: boolean}>`
    user-select: none;
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          display: ${p => p.scrl ? "block" : "none"};
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
`;
/**
 * Анимация точки
 */
export const PointAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {

    opacity: 1;
  }
`;

/**
 * Стрелка
 */
export const Arrow = styled(FlexBox)<{externalLink?: boolean}>`
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 30px;
    padding-top: 6px;
    cursor: pointer;
    animation: ${ArrowAnimation} 0.4s linear forwards;
    ${({externalLink}) => externalLink && 'transform: rotate(-45deg)!important;'}
`;

/**
 * Контейнер выбора
 */
export const ChooserContainer = styled(FlexBox)`
    overflow-y: scroll;
    user-select: none;
    padding-top: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    padding-bottom: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    height: calc(100vh);
    max-height: calc(100vh);
    width: 100%;
    scroll-snap-type: y mandatory;
     scroll-behavior: smooth;
    box-sizing: border-box;
    border: none;
`;


// Тупо точка, которая появляется и исчезает
export const PrettyPoint = styled.div<{ visible: boolean }>`
    display: inline-block;
    opacity: ${(p) => (p.visible ? 1 : 0)};
    animation: ${(p) => (p.visible ? PointAnimation : null)} 0.4s linear forwards;
`;

/**
 * Рамки с прозрачностью
 */
export const ChooserOpacity = styled(FlexBox)`
    width: 100%;
    height: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    top: 0;
    pointer-events: none;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 1000;
    background: ${(p) => p.theme.selectContextModal.background};
    background: rgb(42, 48, 52);
    background: ${(p) => p.theme.selectContextModal.opacityTop};
`;

/**
 * Рамка с прозрачностью для низа
 */
export const ChooserOpacityBottom = styled(ChooserOpacity)`
    top: auto;
    bottom: 0;
    background: ${(p) => p.theme.selectContextModal.opacityBottom};
`;
